import React, {createContext, useEffect, useState} from "react";
import {useFetchHook} from "../../../hooks/useFetchHook";
import fetcher from "../../../fetcher";
import {LEASE_DEAL_DARK} from "../../../contexts/DeskingContext";
import {PURCHASE_DEAL_LIGHT} from "../../../contexts/DealContext";
import useDidMountEffect from "../../../hooks/useDidMountEffect";

export const PDFContext = createContext(null)

export const BasePDF = ({ dealState, initialPDFState, children } ) => {
    const [fetchPDFResponse, fetchPDF] = useFetchHook(fetcher.getPDF)
    const [pdfState, setPDFState] = useState(initialPDFState)

    useEffect(function fetchPDFFromBE(){
        fetchPDF(dealState.id)
    }, []);

    useEffect(function setFetchedPDF(){
        if (fetchPDFResponse?.data?.data && !fetchPDFResponse.loading && !fetchPDFResponse?.error) {
            setPDFState(fetchPDFResponse?.data?.data)
        }
    }, [fetchPDFResponse])

    if (!pdfState) return null;

    const pageColor = dealState.is_purchase ? PURCHASE_DEAL_LIGHT : LEASE_DEAL_DARK

    return (
        <PDFContext.Provider value={{...pdfState, pageColor: pageColor}}>
            {children}
        </PDFContext.Provider>
    )
}